var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "editTagForm",
          attrs: {
            model: _vm.editTagForm,
            rules: _vm.editTagFormRules,
            "label-width": "120px"
          }
        },
        [
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: "品种简介", name: "first" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "品种名称", prop: "tag" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.editTagForm.tag,
                            callback: function($$v) {
                              _vm.$set(_vm.editTagForm, "tag", $$v)
                            },
                            expression: "editTagForm.tag"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "品种介绍", prop: "intro" } },
                      [
                        _c("el-input", {
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.editTagForm.intro,
                            callback: function($$v) {
                              _vm.$set(_vm.editTagForm, "intro", $$v)
                            },
                            expression: "editTagForm.intro"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.onCancel } }, [_vm._v("关闭")])
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }